import { useEffect, useRef } from "react";
import proj4 from "proj4";
import { useLeafletContext } from "@react-leaflet/core";
import { useMap } from "react-leaflet";
import parseGeoraster from "georaster";
import GeoRasterLayer from "georaster-layer-for-leaflet";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import Map1 from "./Map1";


window.proj4 = proj4;

const GeotiffLayer = ({ url, options }) => {
    const geoTiffLayerRef = useRef();
    const context = useLeafletContext();
    const map = useMap();

    useEffect(() => {
        const container = context.layerContainer || context.map;
        // if(container.hasLayer(geoTiffLayerRef.current)){
        //     container.removeLayer(geoTiffLayerRef.current);
        //     console.log('remove')
        // }
        let count = 0;
        //        console.log(Object.keys(context.map._layers).length)
        //        console.log(context.map)
        container.eachLayer((layer) => {
            count++;
            if (layer.georasters) {
                container.removeLayer(layer);
            }
        });

        fetch(url)
            .then((response) => response.arrayBuffer())
            .then((arrayBuffer) => {
                // console.log(arrayBuffer);
                parseGeoraster(arrayBuffer).then((georaster) => {
                    // console.log("georaster:", georaster);
                    options.georaster = georaster;
                    // console.log("option:",options.georaster)
                    geoTiffLayerRef.current = new GeoRasterLayer(options);
                    container.addLayer(geoTiffLayerRef.current);
                    map.fitBounds(geoTiffLayerRef.current.getBounds());
                });
            });
        // container.removeLayer(geoTiffLayerRef.current)
        // geoTiffLayerRef.current

        // return () => {

        //     container.eachLayer(function (layer) {
        //         container.removeLayer(layer)
        //         console.log('layer',geoTiffLayerRef);
        //         // container.removeLayer(geoTiffLayerRef.current)

        //     });

        // container.removeLayer(GeoRasterLayer)
        // }





    }, [context, url, map, !options]);

    return null;
};

export default GeotiffLayer;